// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const DeveloperToolsCsat: MarkdocTagRegistration = {
  tag: 'developer-tools-csat',
  component: 'DeveloperToolsCsat',
};
